import { Record } from 'immutable';

export default class BudgetRecord extends Record({
  id: null,
  year: null,
  month: null,
  profit: null,
  minimumProfit: null,
}) {
}
